// 앱 최상위 컴포넌트 - 로그인 상태에 따라 로그인 화면 또는 메인 화면 표시
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage  from './pages/LoginPage';
import TabLayout  from './components/TabLayout';
import MobileApp  from './mobile/MobileApp';
import './App.css';

// 로그인 여부에 따라 화면 분기
const AppContent = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="app-loading">로딩 중...</div>;
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <Routes>
      {/* 모바일 화면 (/mobile/*) */}
      <Route path="/mobile/*" element={<MobileApp />} />
      {/* PC 화면 (기존 TabLayout, 나머지 모든 경로) */}
      <Route path="*" element={<TabLayout />} />
    </Routes>
  );
};

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  </BrowserRouter>
);

export default App;
